/* Church Website Portfolio - All tech portfolio content has been removed */

// Website related settings
const settings = {
  isSplash: true,
};

// SEO Related settings
const seo = {
  title: "Saint Mary Ethiopian Orthodox Tewahedo Church - Wellington",
  description:
    "Ethiopian Orthodox Tewahedo Church Tsiraha Tsion - Saint Mary Parish of Wellington. A spiritual home for the Ethiopian Orthodox community in Wellington, New Zealand.",
  og: {
    title: "Saint Mary Ethiopian Orthodox Tewahedo Church",
    type: "website",
    url: "https://saintmarywellington.com",
  },
};

// Home Page
const greeting = {
  title:
    "Ethiopian Orthodox Tewahido Church Tsiraha Tsion - Saint Mary Parish Of Wellington",
  logo_name: "Saint Mary Parish Wellington",
  nickname: "A Spiritual Home",
  subTitle:
    "A spiritual home for the Ethiopian Orthodox community in Wellington. United in worship, faith, and the mission to build our permanent church.",
  resumeLink:
    "https://givealittle.co.nz/org/ethiopian-orthodox-tewahido-church",
  portfolio_repository:
    "https://givealittle.co.nz/org/ethiopian-orthodox-tewahido-church",
  githubProfile:
    "https://givealittle.co.nz/org/ethiopian-orthodox-tewahido-church",
};

const socialMediaLinks = [
  {
    name: "Facebook",
    link: "https://www.facebook.com/61585649653841/?http_ref=eyJ0cyI6MTc3MTIyNDg0OTAwMCwiciI6IiJ9",
    fontAwesomeIcon: "fa-facebook-f",
    backgroundColor: "#1877F2",
  },
  {
    name: "WhatsApp",
    link: "https://wa.me/64204142991",
    fontAwesomeIcon: "fa-whatsapp",
    backgroundColor: "#25D366",
  },
  {
    name: "Instagram",
    link: "https://instagram.com/ethiopianorthodoxwellington",
    fontAwesomeIcon: "fa-instagram",
    backgroundColor: "#E4405F",
  },
  {
    name: "YouTube",
    link: "https://www.youtube.com/@tsirahatsionsaintmaryparis525",
    fontAwesomeIcon: "fa-youtube",
    backgroundColor: "#FF0000",
  },
  {
    name: "Twitter",
    link: "https://twitter.com/ethiopianorthodoxwellington",
    fontAwesomeIcon: "fa-twitter",
    backgroundColor: "#1DA1F2",
  },
];

const skills = {
  data: [
    {
      title: "About Our Church",
      fileName: "DataScienceImg",
      skills: [
        "Ethiopian Orthodox Tewahido Church Tsiraha Tsion Saint Mary Parish Of Wellington is a vibrant spiritual community serving Ethiopian Orthodox believers across the Wellington region. We gather for worship, liturgical services, Sunday school, fellowship, and the preservation of our ancient Tewahedo traditions.",
        "Our mission is to provide a permanent spiritual home for current and future generations, rooted in the teachings, sacraments, and traditions handed down from the Apostolic era.",
      ],
      softwareSkills: [],
    },
  ],
};

// Church Features & Services - Professional Font Awesome Icons
const churchFeaturesData = {
  features: [
    {
      id: 1,
      name: "Holy Qurbana (Divine Liturgy)",
      description:
        "Participate in the ancient Ethiopian Orthodox Tewahedo Divine Liturgy, the central act of worship connecting us to the Apostolic tradition.",
      icon: "fa-church",
    },
    {
      id: 2,
      name: "Sacraments of the Church",
      description:
        "Receive the seven sacred mysteries as practiced in the Ethiopian Orthodox Tewahedo tradition.",
      icon: "fa-cross",
    },
    {
      id: 3,
      name: "Spiritual Direction & Confession",
      description:
        "Seek spiritual guidance and confession from our clergy to grow in faith and reconciliation with God.",
      icon: "fa-hands-praying",
    },
    {
      id: 4,
      name: "Fasting & Prayer Disciplines",
      description:
        "Observe the Ethiopian Orthodox Tewahedo fasting calendar with its rich spiritual practices.",
      icon: "fa-calendar-days",
    },
    {
      id: 5,
      name: "Ge'ez Language & Liturgy",
      description:
        "Experience our sacred liturgy in Ge'ez, the ancient ecclesiastical language of the Ethiopian Orthodox Church.",
      icon: "fa-book-open",
    },
    {
      id: 6,
      name: "Community & Cultural Heritage",
      description:
        "Celebrate Ethiopian Orthodox traditions, feast days, and community gatherings that unite us in faith.",
      icon: "fa-people-group",
    },
  ],
};

// Church Building Project
const projectsHeader = {
  title: "Church Building Project",
  description:
    "Our parish has purchased land to build a permanent Ethiopian Orthodox church and community hall in Wellington. This project will provide a place of worship, cultural preservation, education, and gathering for generations to come. We are actively fundraising to complete the construction.",
  avatar_image_path: "projects_image.svg",
};

// Calendar Page
const calendarData = {
  title: "Church Calendar",
  description:
    "Major Ethiopian Orthodox fasting days, feasts, and holy celebrations.",
  events: [
    {
      title: "Sunday Liturgy",
      date: "Every Sunday",
      time: "9:00 AM - 12:00 PM",
      description:
        "Holy Qurbana (Divine Liturgy) - Our main service of worship",
      location: "Church Location",
    },
    {
      title: "Timkat (Epiphany)",
      date: "January 19, 2026",
      description: "Celebration of the Baptism of Our Lord Jesus Christ",
    },
    {
      title: "Fasika (Easter)",
      date: "April 12, 2026",
      description: "Celebration of the Resurrection of Our Lord Jesus Christ",
    },
  ],
};

// Services/Worship Schedule
const servicesData = {
  title: "Worship & Services",
  description: "Join us for our worship services and spiritual activities",
  services: [
    {
      day: "Weekly Liturgy",
      time: "Sundays",
      service: "Weekly Liturgy (Kidase)",
      details: "Our main weekly worship service with Holy Communion",
    },
    {
      day: "Weekday Prayer",
      time: "As Announced",
      service: "Prayer & Fellowship",
      details: "Weekday prayer services and fellowship gatherings",
    },
    {
      day: "Children",
      time: "Saturdays",
      service: "Saturday School for Children",
      details: "Religious education and spiritual formation for children",
    },
    {
      day: "Bible Study",
      time: "Regularly",
      service: "Bible Study & Spiritual Teaching",
      details: "Deep dive into scripture and church teachings",
    },
    {
      day: "Community",
      time: "Ongoing",
      service: "Community Support and Cultural Programs",
      details: "Community outreach and cultural preservation activities",
    },
  ],
};

// Leadership & Contact
const leadershipData = {
  title: "Leadership & Contact",
  description: "Meet our church leadership and get in touch with us",
  leaders: [
    {
      name: "Abba Teklesilassie Bokan",
      role: "The Head Priest",
      email: "tsirhatsion.nz@gmail.com",
      phone: "+64 204 142 9913",
    },
    {
      name: "Deacon Dawit Shafe",
      role: "Spiritual Services Coordinator",
      email: "tsirhatsion.nz@gmail.com",
      phone: "+64 210 828 2278",
    },
  ],
  address: {
    street: "206 Coast Road, Wainuiomata",
    city: "Lower Hutt",
    postalCode: "5373",
    country: "New Zealand",
    mapLink:
      "https://www.google.com/maps/place/206+Coast+Road,+Wainuiomata,+Lower+Hutt+5373",
    mapEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2996.5!2d174.5!3d-41.3!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d0d1f2a%3A0x1234567890!2s206%20Coast%20Road%2C%20Wainuiomata%2C%20Lower%20Hutt%205373!5e0!3m2!1sen!2snz!4v1700000000000",
  },
};

// Donations & Support
const donationsData = {
  title: "Support Our Church",
  description:
    "Help us build our permanent church home and support our mission",
  giveALittleLink:
    "https://givealittle.co.nz/org/ethiopian-orthodox-tewahido-church",
  giveALittleText: "Support us on GiveALittle",
  bankDetails: {
    bankName: "ANZ Bank",
    accountName: "Ethiopian Orthodox Tewahido Church",
    accountNumber: "06-0577-0234805-000",
    referenceNumber: "Church Building Project",
  },
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Us",
    description:
      "For inquiries, blessings, or to learn more about our community, please reach out.",
  },
  blogSection: {
    title: "Email",
    subtitle: "tsirhatsion.nz@gmail.com",
    link: "mailto:tsirhatsion.nz@gmail.com",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Location",
    subtitle: "206 Coast Road, Wainuiomata, Lower Hutt 5373",
    locality: "Wainuiomata",
    country: "New Zealand",
    region: "Lower Hutt",
    streetAddress: "206 Coast Road, Wainuiomata",
    postalCode: "5373",
    avatar_image_path: "address_image.svg",
  },
  phoneSection: {
    title: "Primary Contact",
    subtitle: "+64 204 142 9913",
  },
};

// Placeholder exports for removed sections (keeping for backward compatibility)
const competitiveSites = { competitiveSites: [] };
const degrees = { degrees: [] };
const certifications = {
  certifications: [
    {
      title: "Religious Community Leadership",
      subtitle: "Ethiopian Orthodox Tewahedo Church",
      description:
        "Leadership in spiritual community building and church development",
      certificate_link: "https://stmaryorthodoxwellington.org",
    },
  ],
};
const experience = {
  title: "Leadership Experience",
  sections: [
    {
      title: "Church Leadership",
      work: true,
      experiences: [
        {
          title: "Spiritual Leader",
          company: "Ethiopian Orthodox Tewahedo Church",
          company_url: "https://stmaryorthodoxwellington.org",
          desc:
            "Leading the spiritual community and overseeing church activities, services, and community engagement.",
          date: "2024 - Present",
          location: "Wellington, New Zealand",
        },
      ],
    },
  ],
};
const publicationsHeader = {
  title: "Publications",
  description: "Church announcements and updates.",
  avatar_image_path: "projects_image.svg",
};
const publications = {
  data: [],
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  churchFeaturesData,
  publicationsHeader,
  publications,
  contactPageData,
  calendarData,
  servicesData,
  leadershipData,
  donationsData,
};
